// extracted by mini-css-extract-plugin
module.exports = {"root":"Miscellaneous_root__ue3il"};